// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TicketStructureDialog from "./../dialogs/ticket-structure-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
function TicketServiceStructureRoleModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Role = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.TicketServiceStructureRoleCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteTicketServiceStructureRole");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddTicketServiceStructureToRole":
                self.ShowTicketServiceStructureRoleDialog(self.Role.RoleId(), null, true);
                break;
            case "RemoveTicketServiceStructureFromRole":
                if (self.SelectedRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteTicketServiceStructureRole(self.SelectedRow().OpenData);
                        }
                    });
                }
                break;
            case "EditTicketServiceStructureRole":
                if (self.SelectedRow() != null) {
                    self.ShowTicketServiceStructureRoleDialog(self.Role.RoleId(), self.SelectedRow().TicketServiceStructureRoleId, false);
                }
                break;
        }
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/GetTicketServiceStructureRoleCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedRow(null);
            self.TotalRows(0);
            self.TicketServiceStructureRoleCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.TicketServiceStructureRoleCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    self.AddTicketServiceStructureRole = function (model, roleId) {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/AddTicketServiceStructureRole", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            model: ko.map.toJS(model),
            roleId: roleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteTicketServiceStructureRole = function (itemId) {
        return Bao.post("UadmCustom/RoleTab/DeleteTicketServiceStructureRole", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            itemId: itemId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedRow = ko.observable({});
    self.SelectedRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RemoveTicketServiceStructureFromRole":
                case "EditTicketServiceStructureRole":
                    button.Enabled(!(self.SelectedRow() == null));
                    break;
                case "AddTicketServiceStructureToRole":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("UadmCustom/RoleTab/ResetTicketServiceStructureRole", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmCustom/RoleTab/SaveTicketServiceStructureRoleCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("UadmCustom/RoleTab/CopyTicketServiceStructureRoleCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
    self.ShowTicketServiceStructureRoleDialog = function (roleId, ticketServiceStructureId, isNew) {
        var dialog = new TicketStructureDialog(tabPage, self, "TicketService");
        dialog.ShowTicketStructureRoleDialog(roleId, ticketServiceStructureId, isNew);
    };
}
;
export default TicketServiceStructureRoleModel;